import htmlEntities from '../scripts/html-entities';
import scrollToElement from 'scroll-to-element';
import DOMPurify from 'dompurify';
import merge from 'lodash.merge';

class SiteMessages {

  constructor () {

    this._messages = this.loadMessages();
    this.container = document.querySelector('.site-messages-container');

    this.loadMessages();

  }

  defaultStaticOptions() {
    return {
      id: false,
    }
  }

  defaultOptions() {
    return {
      id: false,
      save: 1,
      autoClose: 1,
      closeButton: true,
    }
  }

  scrollToMessages() {
    scrollToElement(this.container, {
      offset: -50,
    });
  }

  displayMessages(clearMessages = true) {

    this.container = document.querySelector('.site-messages-container');
    if(!this.container) {
      console.error("No site messages container");
      return;
    }

    console.log("messages", this._messages);

    let html = '';

    if(this._messages.length > 0) {
      html = `
      <div class="site-messages">
        ${this._messages.map(message => {
          return `
          <div class="site-message site-message--${htmlEntities(message.type)}" 
            data-autoclose="${message.options.autoClose}"
            ${message.options.id ? `data-id="${htmlEntities(message.options.id)}"` : ''}
          >
            <div class="site-message__content">
              ${DOMPurify.sanitize(message.message)}
            </div>
            ${message.options.closeButton ? `
            <div class="site-message__close">
              <button class="site-message__close__button">
                <i class="fas fa-times"></i>
              </button>
            </div>
            ` : ''}
            
          </div>
          `
        }).join('')}
      </div>
      `
    }

    this.container.innerHTML = html;

    console.log(this.container, html);

    let messages = this.container.querySelectorAll('.site-message');

    if(messages) {

      messages = Array.from(messages);

      messages.forEach((message, i) => {

        let autoCloseTimeout = null;

        if($(message).data('autoclose') == 1) {

          autoCloseTimeout = setTimeout(() => {

            this.closeMessage(message);

          }, 10000 * (i + 1));

        }

        const closeBtn = message.querySelector('.site-message__close__button');

        if(closeBtn) {
          closeBtn.addEventListener('click', () => {
            clearTimeout(autoCloseTimeout);
            this.closeMessage(message);
          });
        }

      });

    }

    if(clearMessages) {
      this.clearMessages();
    }

  }

  /**
   * Collapse a message to nothing, then remove it.
   *
   * The height the collapse animates *from* is measured here, at close time. It used
   * to be pinned on every message the moment it rendered, which silently froze any
   * message whose content arrives afterwards: the account context bar was queued as
   * an empty placeholder and filled when /account/contexts resolved, so its box
   * stayed the 26px of the empty div while the real bar grew to 78px, and the page's
   * own content laid itself out against the short box and slid up underneath it. The
   * bar has since moved out of this container entirely (see
   * AccountSwitcher.ensureHost()), but any message whose content lands after the
   * render has the same shape of problem.
   *
   * Measuring at close time is what a height transition wants anyway, and nothing
   * needs a height before then.
   */
  closeMessage(message) {

    $(message).css('height', `${message.getBoundingClientRect().height}px`);

    // Read back a layout property so the explicit height lands as its own style
    // change; without it the browser coalesces both writes and there is nothing to
    // animate from.
    void message.offsetHeight;

    $(message).css('height', '0px');
    message.classList.add('animate-close');

    setTimeout(() => {
      message.parentNode.removeChild(message);
    }, 500);

  }

  clearMessages() {
    this._messages = [];
    this.saveMessages();
  }

  getMessages() {
    return this._messages;
  }

  removeMessageById(messageId) {

    if(this.container) {
      let messages = this.container.querySelectorAll('.site-message');

      if (messages) {

        messages = Array.from(messages);

        messages.forEach((message, i) => {
          if ($(message).data('id') == messageId) {
            $(message).remove();
          }
        });

      }
    }

  }

  addMessage(type, message, options = {}) {

    options = merge(this.defaultOptions(), options);

    // message id is unique, only add once
    if(options.id) {
      if(this._messages.length > 0) {
        for(let i = 0; i < this._messages.length; i++) {
          if(this._messages[i].options.id === options.id) {
            return;
          }
        }
      }
    }

    this._messages.push({
      message,
      type,
      options,
    });

    if(options.save) {
      this.saveMessages();
    }

  }

  saveMessages() {
    localStorage.setItem('siteMessages', JSON.stringify(this._messages));
  }

  loadMessages() {

    const messages = localStorage.getItem('siteMessages');

    if(messages) {
      return JSON.parse(messages);
    } else {
      return [];
    }

  }

}

const SiteMessagesInstance = new SiteMessages();

export default SiteMessagesInstance;
